
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/company/access",
      function () {
        return require("private-next-pages/en/company/access.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/company/access"])
      });
    }
  